"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Countdown = _interopRequireDefault(require("../../../Countdown"));
var _iconsReact = require("../../../../icons-react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var RoundCountdown = function RoundCountdown(_ref) {
  var className = _ref.className,
    seconds = _ref.seconds,
    onStop = _ref.onStop;
  if (!Number.isInteger(seconds) && seconds <= 0) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledRoundCountdown, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledCountdown, {
    format: "ss",
    seconds: seconds,
    onStop: onStop
  }), /*#__PURE__*/_react["default"].createElement(StyledCircleIcon, {
    duration: "".concat(seconds, "s")
  }));
};
var StyledRoundCountdown = _styledComponents["default"].div.withConfig({
  displayName: "RoundCountdown__StyledRoundCountdown",
  componentId: "sc-1pef45d-0"
})(["width:24px;height:24px;line-height:24px;text-align:center;position:relative;"]);
var StyledCountdown = (0, _styledComponents["default"])(_Countdown["default"]).withConfig({
  displayName: "RoundCountdown__StyledCountdown",
  componentId: "sc-1pef45d-1"
})(["color:#4d4d4d;font-size:12px;font-weight:normal;"]);
var StyledCircleIcon = (0, _styledComponents["default"])(_iconsReact.Circle).withConfig({
  displayName: "RoundCountdown__StyledCircleIcon",
  componentId: "sc-1pef45d-2"
})(["width:24px;height:24px;top:0;left:0;position:absolute;circle{stroke-width:2;stroke:#00c781;stroke-dasharray:70;stroke-dashoffset:70;", "}@keyframes progress{0%{stroke-dashoffset:0;}100%{stroke-dashoffset:70;}}"], function (_ref2) {
  var duration = _ref2.duration;
  return "\n      animation: progress ".concat(duration, " linear;\n    ");
});
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(RoundCountdown);